import { Box, Container, Stack, Typography } from "@mui/material"
import PhoneIcon from '@mui/icons-material/Phone';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';
import { isMobile } from "react-device-detect";

function Contact() {
  return (
    <Box id="contact" sx={{ backgroundColor: "rgb(255, 255, 255);" }}>
      <Container sx={{
        display: "flex",
        flexDirection: "column",
        py: 4
      }}>
        <Stack spacing={2} useFlexGap >
          <Typography variant="h4" component="h2">Kontakta oss</Typography>

          <Stack direction="row" alignItems="center" gap={1}>
            <PhoneIcon color="primary" />
            {isMobile
              ? <Typography
                variant="caption"
                component="a"
                href={`tel:+46733790742`}
                target="_blank">
                +46733790742
              </Typography>
              : <Typography variant="caption">+46733790742</Typography>
            }
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <EmailIcon color="primary" />
            <Typography
              variant="caption"
              component="a"
              target="_top"
              rel="noopener noreferrer"
              href="mailto:info@lokalaparlor.com">
              info@lokalaparlor.com
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <FacebookIcon color="primary" />
            <Typography
              variant="caption"
              component="a"
              target="_blank"
              href="https://www.facebook.com/people/Lokala-P%C3%A4rlor/61573100699004/">
              Facebook
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <InstagramIcon color="primary" />
            <Typography
              variant="caption"
              component="a"
              target="_blank"
              href="https://www.instagram.com/lokalaparlor/">
              Instagram
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Box>
  )
}

export default Contact;